import dayjs from "dayjs";
import styled from "styled-components";
import { Image } from "react-bootstrap";
import CheckRefPayment from "./CheckRefPayment";
import ChangeStatusComponent from "./ChangeStatusComponent";

type ITimeProp = {
  time: string | number | Date;
};

const TimestampContainer = styled.div`
  font-size: 0.8rem;
  span {
    color: #777;
  }
`;

export const Timestamp = (props: ITimeProp) => {
  const { time } = props;
  const date = dayjs(time).format("DD/MM/YYYY");
  return (
    <TimestampContainer>
      <strong>วันที่บันทึก</strong> <span>{date}</span>
    </TimestampContainer>
  );
};

type IProfileProp = {
  pictureUrl: string;
  displayName: string;
  productName: string;
  refPayment: string | undefined;
  isCoupon?: boolean;
  status: number;
  uid: string;
  bookingId: string;
  fetchData: () => void;
};

const ProfileContainer = styled.div`
  display: flex;
  margin: 0.25rem 0 0.5rem 0;
  align-items: center;

  div.container-ref {
    display: flex;
    margin: 0 0 0 auto;
    align-items: center;
  }

  div.button-status {
    margin: 0 0.5rem;
  }
`;

const ProfileCard = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 0.5rem;
  span {
    font-size: 0.8rem;
    color: #777;
  }
`;

export const HeaderProfileComponent = (props: IProfileProp) => {
  const {
    pictureUrl,
    displayName,
    productName,
    isCoupon,
    refPayment,
    status,
    uid,
    bookingId,
    fetchData,
  } = props;
  return (
    <ProfileContainer>
      <Image src={pictureUrl} roundedCircle width={40} height={40} />
      <ProfileCard>
        <strong>{displayName}</strong>
        <span>
          Package {productName}{" "}
          {isCoupon ? (
            <Image
              src={"./coupon.png"}
              alt={`coupon`}
              height={20}
              width={20}
              style={{ margin: "0 auto 0.1rem 0" }}
            />
          ) : (
            <></>
          )}
        </span>
      </ProfileCard>
      <div className="container-ref">
        <CheckRefPayment size="40" refPayment={refPayment} />
        <div className="button-status">
          <ChangeStatusComponent
            status={status}
            uid={uid}
            bookingId={bookingId}
            fetchData={fetchData}
          />
        </div>
      </div>
    </ProfileContainer>
  );
};

const ContainerTable = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 0.25rem;
`;

const DescriptionContainer = styled.div`
  font-size: 0.8rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  width: 10rem;
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin: 0;
`;

export const Description = (props: {
  description: string;
  doctorId?: string | undefined | null;
}) => {
  const { description, doctorId } = props;
  return (
    <ContainerTable>
      <DescriptionContainer>{description}</DescriptionContainer>
      {doctorId && (
        <DescriptionContainer>ผู้ดูแล : {doctorId}</DescriptionContainer>
      )}
    </ContainerTable>
  );
};
